function capitalize(str) {
  let words = str.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1); 
  }
  let capitalizedStr = words.join(" ");
  return capitalizedStr;
}


function getEffectiveVariantPriceCents(variant) {
  if (!variant) return 0;

  const igPrice = window.igData?.price?.getPriceByVariantId?.(variant.id);

  if (igPrice != null && igPrice !== '') {
    const dollars = parseFloat(String(igPrice).replace(/[^0-9.]/g, ''));
    if (!Number.isNaN(dollars)) {
      return Math.round(dollars * 100);
    }
  }

  return parseInt(variant.price, 10) || 0;
}

class BtnUpload extends HTMLElement {
  constructor() {
    super();
    console.log("%cUPLOADING", "background:green;color:white;padding:10px");

    this.uploadKitEv = new Event('adduploadkit');
    
    this.inputs = {};
    this.type = this.dataset.type;

    this.onWaitUploadKit();

    this.addEventListener('adduploadkit', () => {
      let nameInput = false;
      
      const product = JSON.parse(document.querySelector('#step-block-product').textContent);
      const nameTag = [
        'upload with custom text',
        'upload and text',
        'upload with pets name',
        'upload two pets with name',
        'upload three pets with name',
        'upload four pets with name',
        'upload five pets with name',
        'upload six pets with name',
        'upload with name and location',
      ];

      for (const tag of product.tags) {
        nameInput = nameTag.includes(tag);
        if(nameInput) break;
      }

      if(nameInput) {
        if (this.type === 'ages') {
          this.querySelectorAll('.uploadkit-button').forEach( (btn, arg) => {
            let proName = btn.dataset['uploaderName'];
      
            const label = document.createElement('label');
            let num = arg;
            if(document.querySelectorAll('.uploadkit-button').length > 1) {
              num = arg + 1;
            } else {
              num = '';
            }
    
            const labelName = document.createTextNode(`Age / Caption ${num}`);
            label.appendChild(labelName);
      
            const inputName = document.createElement('input');
            inputName.setAttribute('type', 'text');
            inputName.setAttribute('class', 'pet-name');
            inputName.setAttribute('name', `properties[_${proName}_age]`);
            inputName.setAttribute('placeholder', num === 1 ? 'e.g. Puppy / Kitten / Then / 8 Weeks Old' : 'e.g. Adult / Now / 4 Years Old');
            inputName.setAttribute('value', '');
      
            const pet_name = document.createElement('div');
            pet_name.classList.add('pet_name');
      
            pet_name.appendChild(label);
            pet_name.appendChild(inputName);
      
            btn.after(pet_name);
            let property = JSON.parse( `{"_${proName}\":"","_${proName} (direct link)":"","_${proName}_age":""}`);
            this.inputs.properties = {...this.inputs.properties, ...property};
          });
        } else if (this.type === 'additional text') {
          this.querySelectorAll('.uploadkit-button').forEach( (btn, arg) => {
      
            const label = document.createElement('label');

            let proName = arg === 0 ? 'left' : 'right';
    
            const labelName = document.createTextNode(`${arg === 0 ? 'Left photo name' : 'Right photo name'}`);
            label.appendChild(labelName);
      
            const inputName = document.createElement('input');
            inputName.setAttribute('type', 'text');
            inputName.setAttribute('class', 'pet-name');
            inputName.setAttribute('name', `properties[_${proName}_petName]`);
            inputName.setAttribute('placeholder', 'e.g Tom, Bruno, etc.');
            inputName.setAttribute('value', '');
      
            const pet_name = document.createElement('div');
            pet_name.classList.add('pet_name');
      
            pet_name.appendChild(label);
            pet_name.appendChild(inputName);
      
            btn.after(pet_name);
            let property = JSON.parse( `{"_${proName}\":"","_${proName} (direct link)":"","_${proName}_petName":""}`);
            this.inputs.properties = {...this.inputs.properties, ...property};
          });
        } else {
          this.querySelectorAll('.uploadkit-button').forEach( (btn, arg) => {
            let proName = btn.dataset['uploaderName'];
      
            const label = document.createElement('label');
            let num = arg;
            if(document.querySelectorAll('.uploadkit-button').length > 1) {
              num = arg + 1;
            } else {
              num = '';
            }
    
            const labelName = document.createTextNode(`Pet Name ${num}`);
            label.appendChild(labelName);
      
            const inputName = document.createElement('input');
            inputName.setAttribute('type', 'text');
            inputName.setAttribute('class', 'pet-name');
            inputName.setAttribute('name', `properties[_${proName}_petName]`);
            inputName.setAttribute('placeholder', 'e.g Tom, Bruno, etc.');
            inputName.setAttribute('value', '');
      
            const pet_name = document.createElement('div');
            pet_name.classList.add('pet_name');
      
            pet_name.appendChild(label);
            pet_name.appendChild(inputName);
      
            btn.after(pet_name);
            let property = JSON.parse( `{"_${proName}\":"","_${proName} (direct link)":"","_${proName}_petName":""}`);
            this.inputs.properties = {...this.inputs.properties, ...property};
          });
        }
        if (document.querySelector('#additional-text')) {
          this.inputs.properties = {
            ...this.inputs.properties,
            _additional_text: ""
          };
        }
        if (document.querySelector('#pet-name')) {
          this.inputs.properties = {
            ...this.inputs.properties,
            _pet_name: ""
          };
        }
      }
      console.log(this.inputs);
    });
  }

  onWaitUploadKit() {
    let uploadkit = setInterval(() => {
      if(this.querySelector('.uploadkit-button')) {
        this.dispatchEvent(this.uploadKitEv);
        clearInterval(uploadkit);
      }
    }, 500);
  }

}
customElements.define('upload-btn-wrapper', BtnUpload);

class BtnBefore extends HTMLElement {
  constructor() {
    super();

    this.beforeEv = new Event('before', {bubbles: true});

    this.addEventListener('click', this.onBeforeClick.bind(this));
  }

  onBeforeClick(event) {
    event.preventDefault();
    // debugger;
    this.dispatchEvent(this.beforeEv);
  }
}
customElements.define('before-btn', BtnBefore);

class BtnNext extends HTMLElement {
  constructor() {
    super();

    this.nextEv = new Event('next', {bubbles: true});

    this.addEventListener('click', this.onNextClick.bind(this));
  }

  onNextClick(event) {
    event.preventDefault();
    // debugger;
    this.dispatchEvent(this.nextEv);
  }
}
customElements.define('next-btn', BtnNext);

class OptionItem extends HTMLElement {
  constructor() {
    super();

    this.selectEv = new Event('selectopt', {bubbles: true});

    this.addEventListener('click', this.onSelectOption.bind(this));
  }

  connectedCallback() {
    this.v_option = this.dataset['v_option'];
    this.step = this.dataset['option'];
    let parentEl = document.querySelector(`[data-step="${this.step}"]`) || this.parentElement;
    try {
      const siblings = Array.from(parentEl.querySelectorAll('option-item'))
        .filter(sibling => sibling !== this);
      this.siblings = siblings.length ? siblings : null;
    } catch (err) {
      console.error(`Error selecting siblings: ${err.message}`);
      this.siblings = null;
    }
  }

  onSelectOption() {
    if (!this.siblings) return;
    this.siblings.forEach(sibling => sibling.classList.toggle('selected', false));

    this.classList.toggle('selected', true);
    setTimeout(() => {
      this.dispatchEvent(this.selectEv);
    }, 300);
  }
}
customElements.define('option-item', OptionItem);

class ExtraAdd extends HTMLElement {
  constructor() {
    super();
    this.v_id = this.dataset['v_id'];

    this.addExtraEv = new Event('addextra', {bubbles: true});
    this.removeExtraEv = new Event('removeextra', {bubbles: true});

    this.addEventListener('click', this.updateState.bind(this));
  }

  updateState(ev) {
    ev.preventDefault();

    if(this.classList.contains('added')) {
      this.classList.remove('added');
      this.dispatchEvent(this.removeExtraEv);
    } else {
      this.classList.add('added');
      this.dispatchEvent(this.addExtraEv);
    }
  }
}
customElements.define('extra-add', ExtraAdd); 

class StepBlock extends HTMLElement {
  constructor() {
    super();

    if (!StepBlock._instance) {
      StepBlock._instance = this;
    }
    
    this.steps = [];
    this.url = new URL(window.location.href);
    this.cur_symbol = document.querySelector('#currency_symbol').textContent;
    this.product = JSON.parse(document.querySelector('#step-block-product').textContent);
    this.steps = this.buildStepsFromDom();
    if (!this.steps.length) {
      this.product.options.forEach(option => {
        this.steps.push(option.toLowerCase());
      });
      this.steps.push('upload', 'extra');
    }
    let m_product_containers = document.querySelectorAll('.step-block-product_metafields');
    this.m_products = [];
    for (const element of m_product_containers) {
      let m_product = JSON.parse(element.textContent);
      this.m_products.push(m_product);
    }
    
    localStorage.setItem('custom_product', this.product.handle);
    let extra_title = document.querySelector('#step-extras .process-name').textContent;
    localStorage.setItem('extra_title', extra_title);

    localStorage.setItem('m_products', JSON.stringify(this.m_products));

    let curVariantID = this.url.searchParams.get("variant");

    this.cur_variant = curVariantID && this.product.variants.find(variant => variant.id == curVariantID) ? this.product.variants.find(variant => variant.id == curVariantID) : this.product.variants.find(variant => variant.available);

    if (this.cur_variant) {
      this.cur_options = this.cur_variant.options.join();
      let optionNames = this.product.options;
      this.cur_variant.options.forEach( (option, arg) => {
        document.querySelectorAll(`[data-step="${optionNames[arg]}"] option-item`).forEach( item => {
          let v_option = item.dataset['v_option'];
          v_option == option ? item.classList.toggle('selected', true) : null;
        })
      });
      this.dataset['v_id'] = this.cur_variant.id;
      
      this.url.searchParams.set("variant", this.cur_variant.id);
      window.history.replaceState({}, "", this.url);
    }

    this.items = [
      {
        id: this.cur_variant.id,
        quantity: 1,
        price: this.cur_variant.price,
        properties: {
          '__step-product': true
        }
      }
    ];

    this.giftMessageEnabled = false;
    this.giftMessageVariantId = null;
    this.giftMessagePrice = 0;
    this.giftMessageText = '';

    this.addCartEv = new Event('customaddcart', {bubbles: true});

    this.beforeBtn = this.querySelector('before-btn');
    this.nextBtn = this.querySelector('next-btn');
    this.addCartBtn = this.querySelector('.atc-btn');
    this.uploadWrap = this.querySelector('upload-btn-wrapper');
    
    this.setStep(0, false);

    this.addActions();

    this.updateExtraPrintsAvailability();
    this.updateSubTotal();
    this.updateGiftMessageVisibility();
    this.refreshPremiumsWhenIgReady();

    // After a "Make another" reload, confirm the previous add by opening the cart.
    try {
      if (sessionStorage.getItem('sbs_make_another')) {
        sessionStorage.removeItem('sbs_make_another');
        setTimeout(() => {
          if (typeof reBuildCart === 'function') reBuildCart();
          if (typeof open_cart_drawer === 'function') open_cart_drawer();
        }, 400);
      }
    } catch (e) {}

  }


  refreshPremiumsWhenIgReady() {
    const refreshCurrent = () => {
      const index = this.getStepIndex();
      const step = this.steps[index];

      if (step != 'upload' && step != 'extra') {
        this.updatePremium(index);
      }
    };

    if (typeof window.igData?.price?.getPriceByVariantId === 'function') {
      refreshCurrent();
      return;
    }

    const startedAt = Date.now();
    const intervalId = window.setInterval(() => {
      if (!this.isConnected) {
        window.clearInterval(intervalId);
        return;
      }

      const ready =
        typeof window.igData?.price?.getPriceByVariantId === 'function';
      const timedOut = Date.now() - startedAt >= 5000;

      if (!ready && !timedOut) return;

      window.clearInterval(intervalId);

      if (ready) {
        refreshCurrent();
      }
    }, 200);
  }

  /**
   * @returns {boolean}
   */
  isDigitalDownloadVariant() {
    return this.cur_variant?.options?.[0] === 'Digital Download';
  }

  updateGiftMessageVisibility() {
    const isDigital = this.isDigitalDownloadVariant();

    document
      .querySelectorAll('.tw-gift-message-extra, tw-gift-message-toggle')
      .forEach((element) => {
        element.classList.toggle('hidden', isDigital);
      });

    if (!isDigital) {
      return;
    }

    this.giftMessageEnabled = false;
    this.giftMessageVariantId = null;
    this.giftMessagePrice = 0;
    this.giftMessageText = '';

    document.querySelectorAll('tw-gift-message-toggle').forEach((toggle) => {
      if (!toggle.isEnabled) {
        return;
      }

      toggle.setEnabled(false, { skipModal: true, skipSync: true });
    });
  }

  connectedCallback() {
    if (this._connected) return;
    this._connected = true;

    const domSteps = this.buildStepsFromDom();
    if (!domSteps.length) return;

    const stepsChanged = domSteps.join('|') !== this.steps.join('|');
    if (!stepsChanged) return;

    const currentIndex = this.getStepIndex();
    this.steps = domSteps;
    this.setStep(
      Math.min(currentIndex, this.steps.length - 1),
      false
    );
  }

  updateWasPrice() {
  if (!this.cur_variant) return;

  // Running subtotal (matches updateSubTotal): non-bypassed items × qty + gift message.
  let subCents = this.items.reduce((s, i) => s + (i.bypassSubtotal ? 0 : (parseInt(i.price) || 0) * (parseInt(i.quantity) || 1)), 0);

  // Running "was" total: each line's compare-at when higher than its own price, × qty
  // (the main line's qty rises with Extra Prints).
  const mainQty     = parseInt(this.items[0] && this.items[0].quantity) || 1;
  const mainPrice   = parseInt(this.cur_variant.price) || 0;
  const mainCompare = parseInt(this.cur_variant.compare_at_price) || 0;
  let wasCents = (mainCompare > mainPrice ? mainCompare : mainPrice) * mainQty;
  for (const i of this.items.slice(1)) {
    if (i.bypassSubtotal) continue;
    const p = parseInt(i.price) || 0;
    const c = parseInt(i.compare) || 0;
    wasCents += (c > p ? c : p) * (parseInt(i.quantity) || 1);
  }

  // Gift message has no compare-at, so it adds equally to both (savings unaffected).
  if (this.giftMessageEnabled && this.giftMessageText && this.giftMessagePrice && !this.isDigitalDownloadVariant()) {
    const g = parseInt(this.giftMessagePrice) || 0;
    subCents += g;
    wasCents += g;
  }

  // Fast Track has no compare-at, so it adds equally to both (savings unaffected).
  if (window.FastTrack) {
    const ft = window.FastTrack.priceCents(this) || 0;
    subCents += ft;
    wasCents += ft;
  }

  const holder     = this.querySelector('[data-compare-holder]') || this.querySelector('.subtotal--compare-price');
  const moneyEl    = this.querySelector('[data-compare-money]')  || this.querySelector('.compare--price-money');
  const saveHolder = this.querySelector('[data-save-holder]');
  const saveMoney  = this.querySelector('[data-save-money]');

  const hasDiscount = wasCents > subCents;

  if (holder && moneyEl) {
    if (hasDiscount) {
      holder.style.display = '';
      moneyEl.textContent = `${this.cur_symbol}${(wasCents / 100).toFixed(2)}`;
    } else {
      holder.style.display = 'none';
    }
  }
  if (saveHolder && saveMoney) {
    if (hasDiscount) {
      saveHolder.style.display = '';
      saveMoney.textContent = `${this.cur_symbol}${((wasCents - subCents) / 100).toFixed(2)}`;
    } else {
      saveHolder.style.display = 'none';
    }
  }
}

  buildStepsFromDom() {
    const steps = [];

    this.querySelectorAll('.step-process').forEach((stepEl) => {
      const stepId = stepEl.id;
      if (!stepId) return;

      if (stepId === 'step-upload') {
        steps.push('upload');
        return;
      }

      if (stepId === 'step-extra-prints') {
        steps.push('extra_prints');
        return;
      }

      if (stepId === 'step-extras') {
        steps.push('extra');
        return;
      }

      if (stepId === 'step-background') {
        const option = this.product.options.find((name) => {
          const optionLower = name.toLowerCase();
          return optionLower === 'color' || optionLower === 'tray color' || optionLower === 'theme' || optionLower === 'style';
        });
        if (option) steps.push(option.toLowerCase());
        return;
      }

      if (stepId === 'step-size') {
        const option = this.product.options.find((name) => {
          const optionLower = name.toLowerCase();
          return optionLower === 'size' || optionLower === 'format';
        });
        if (option) steps.push(option.toLowerCase());
        return;
      }

      if (stepId === 'step-frame') {
        const option = this.product.options.find((name) => {
          const optionLower = name.toLowerCase();
          return optionLower === 'frame' || optionLower === 'framing option';
        });
        if (option) steps.push(option.toLowerCase());
        return;
      }

      if (stepId === 'step-logo') {
        const option = this.product.options.find((name) => {
          const optionLower = name.toLowerCase();
          return optionLower === 'logo' || optionLower === 'art size';
        });
        if (option) steps.push(option.toLowerCase());
      }
    });

    if (steps.length) return steps;

    this.product.options.forEach((option) => {
      steps.push(option.toLowerCase());
    });
    steps.push('upload', 'extra');
    return steps;
  }

  getStepIndex() {
    const index = parseInt(this.dataset.index, 10);
    return Number.isNaN(index) ? 0 : index;
  }

  getVariantStepIndex(step) {
    return this.product.options.findIndex((option) => option.toLowerCase() === step);
  }

  getStepProcessSelector(step) {
    const selectorMap = {
      upload: '#step-upload',
      extra_prints: '#step-extra-prints',
      extra: '#step-extras',
      color: '#step-background',
      'tray color': '#step-background',
      theme: '#step-background',
      style: '#step-background',
      size: '#step-size',
      format: '#step-size',
      frame: '#step-frame',
      'framing option': '#step-frame',
      logo: '#step-logo',
      'art size': '#step-logo',
    };

    return selectorMap[step] || null;
  }

  getVisibleStepProcesses() {
    return this.steps
      .map((step) => {
        const selector = this.getStepProcessSelector(step);
        return selector ? this.querySelector(selector) : null;
      })
      .filter(Boolean);
  }

  refreshNavButtons() {
    this.beforeBtn = this.querySelector('before-btn');
    this.nextBtn = this.querySelector('next-btn');
  }

  addActions() {
    if (this._actionsAdded) return;
    this._actionsAdded = true;

    this._onSelectOption = this.onSelectOption.bind(this);
    this._onBeforeStep = this.onBeforeStep.bind(this);
    this._onNextStep = this.onNextStep.bind(this);
    this._onAddExtra = this.onAddExtra.bind(this);
    this._onRemoveExtra = this.onRemoveExtra.bind(this);

    this.addEventListener('selectopt', this._onSelectOption);
    this.addEventListener('before', this._onBeforeStep);
    this.addEventListener('next', this._onNextStep);
    this.addEventListener('addextra', this._onAddExtra);
    this.addEventListener('removeextra', this._onRemoveExtra);
    // Extra Prints step (optional): a radio bumps the main line's quantity.
    this._onExtraPrints = this.onExtraPrints.bind(this);
    this.addEventListener('change', this._onExtraPrints);
    this.addEventListener('customaddcart', this.onAddCart);
    this.addCartBtn.addEventListener('click', () => {
      if (this._addPending) return;
      this._makeAnother = false; // normal Add to cart: never the make-another path
      this.dispatchEvent(this.addCartEv);
    });
    // Fast Track (optional next-batch card) flips independently — re-total on change.
    this._onFtChange = () => this.updateSubTotal();
    document.addEventListener('fasttrack:change', this._onFtChange);
    // Optional "Add to cart + Make another": same add flow, but reload fresh after.
    this.makeAnotherBtn = this.querySelector('[data-sbs-make-another]');
    if (this.makeAnotherBtn) {
      this.makeAnotherBtn.addEventListener('click', () => {
        if (this._addPending) return;
        this._makeAnother = true;
        this.makeAnotherBtn.classList.add('loading');
        this.dispatchEvent(this.addCartEv);
      });
    }
  }

  onSelectOption(ev) {
    const stepIndex = this.getStepIndex();
    const variantOptionIndex = this.getVariantStepIndex(this.steps[stepIndex]);
    if (variantOptionIndex < 0) return;

    this.updateVariant(variantOptionIndex, ev.target.v_option);
  }
  
  onBeforeStep() {
    let index = this.getStepIndex();
    index = Math.max(0, index - 1);

    if (this.cur_variant.options[0] == "Digital Download") {
      if (index == 1) {
        this.setStep(0);
      } else {
        this.setStep(index);
      }
    } else {
      this.setStep(index);
    }
  }
  
  onNextStep() {
    const currentIndex = this.getStepIndex();
    const current = this.steps[currentIndex];
    const maxIndex = this.steps.length - 1;
    let index = Math.min(currentIndex + 1, maxIndex);

    if(current == 'upload') {
      var validated = true;
      var imageAttrContainers = $(this).find('.uploadkit-attribute-container');

      if (window.UploadKit && imageAttrContainers.length > 0 ) {
          for(var i=0; i<imageAttrContainers.length; i++) {
              if(imageAttrContainers[i].innerHTML === '') {
                  validated = false;
              }
          }

      }
      
      if(this.items[0]['properties'] == undefined) {
        Object.assign(this.items[0].properties, { ...this.uploadWrap.inputs.properties });
      }

      this.uploadWrap.querySelectorAll('input').forEach(input => {
        let key = input.name.replace('properties[', '').replace(']','');
        this.items[0]['properties'][key] = input.value;
      });

      console.log( this.items);
      if (validated) {
        this.setStep(index);
      } else {
          $('.mb_container').fadeIn();
          // alert('Please upload image first');
      }
    }
    else {
      if (this.cur_variant.options[0] == "Digital Download") {
        if (index == 1) {
          this.setStep(2);
        } else {
          this.setStep(index);
        }
      } else {
        this.setStep(index);
      }
    }
  }

  setStep(index, scroll=true) {
    index = parseInt(index, 10);
    if (Number.isNaN(index) || index < 0) index = 0;
    if (index >= this.steps.length) index = this.steps.length - 1;

    this.refreshNavButtons();

    this.dataset['index'] = index;
    this.dataset['current'] = this.steps[index];

    let before, next, limit;

    limit = this.steps.length;
    
    index > 0 ? before = this.steps[index - 1] : before = this.steps[0];
    index < --limit ? next = this.steps[index + 1] : next = this.steps[this.steps.length - 1];

    if (this.beforeBtn) {
      this.beforeBtn.dataset['index'] = index;
      this.beforeBtn.dataset['current'] = this.steps[index];
      this.beforeBtn.dataset['before'] = before;
      this.beforeBtn.dataset['next'] = next;
    }

    if (this.nextBtn) {
      this.nextBtn.dataset['index'] = index;
      this.nextBtn.dataset['current'] = this.steps[index];
      this.nextBtn.dataset['before'] = before;
      this.nextBtn.dataset['next'] = next;
    }

    this.querySelectorAll('.step-process').forEach((process) => {
      process.classList.remove('active');
      process.classList.remove('current');
    });

    this.getVisibleStepProcesses().forEach((process, arg) => {
      if (arg == index) {
        process.classList.add('current');
      } else if (arg < index) {
        process.classList.add('active');
      }
    });

    if (this.steps[index] != 'upload' && this.steps[index] != 'extra') {
      this.updatePremium(index);
    }

    if(scroll) {
      console.log(window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
      if(window.innerWidth < 1024 ) {
        window.scrollTo(0, window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
      }
    }
    if(this.steps[index] == 'extra') {
      window.scrollTo(0, window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
    }
  }

  updatePremium(stepsIndex) {
    const stepName = this.steps[stepsIndex];
    const variantOptionIndex = this.getVariantStepIndex(stepName);
    if (variantOptionIndex < 0) return;

    const curOption = this.cur_variant.options;
    let step = capitalize(stepName);
    let symbol = this.cur_symbol;

    const subVariants = this.product.variants.filter( variant => {
      let isPassed = true;
      let i = 0;

      do {
        if (i != variantOptionIndex) {
          variant.options[i] === curOption[i] ? isPassed = true : isPassed = false;
        }
        if(!isPassed) return isPassed;
        i++;
      } while (i < curOption.length);
      return isPassed
    });

    let premiumPrices = {};
    let premiumVariantIds = {};
    let curPrice = getEffectiveVariantPriceCents(this.cur_variant);

    subVariants.forEach( variant => {
      let delta = getEffectiveVariantPriceCents(variant) - curPrice;
      const optionValue = variant.options[variantOptionIndex];
      premiumPrices[optionValue] = delta;
      premiumVariantIds[optionValue] = variant.id;
    });

    console.log(subVariants, premiumPrices);

    const parent = document.querySelector(`[data-step="${step}"]`);
    if (!parent) return;

    parent.querySelectorAll('option-item').forEach( item => {
      let value = item.dataset['v_option'];
      let premiumPrice = premiumPrices[value];
      switch(step) {
        case 'Frame':
        case 'Framing Option': {
          const framePriceEl = item.querySelector('.frame-price');
          if (!framePriceEl) break;

          if (premiumVariantIds[value]) {
            framePriceEl.setAttribute(
              'data-variant-id',
              premiumVariantIds[value],
            );
          } else {
            framePriceEl.removeAttribute('data-variant-id');
          }

          framePriceEl.innerHTML = premiumPrice > 0
            ? `+${symbol}${premiumPrice / 100}`
            : '';
          break;
        }
        case 'Size':
          premiumPrice > 0 ? item.querySelector('.size-wrapper').innerHTML = `<div class="add-price">+${symbol}${premiumPrice/100}</div>` : item.querySelector('.size-wrapper').innerHTML = '';
          break;
        case 'Color':
        case 'Tray Color':
        case 'Theme':
          premiumPrice > 0 ? item.querySelector('.bg-wrapper').innerHTML = `<div class="add-price">+${symbol}${premiumPrice/100}</div>` : item.querySelector('.bg-wrapper').innerHTML = '';
          break;
      }
    });
  }

  // Extra Prints: N extra copies of the same print → main line quantity = 1 + N.
  // "None" (count 0) resets to a single print. Same-art quantity model (like wall art).
  onExtraPrints(ev) {
    const input = ev.target;
    if (!input || !input.matches || !input.matches('[data-sbs-extra-prints]')) return;
    // A digital download is one file — extra copies would only multiply its price.
    const count = this.isDigitalDownloadVariant() ? 0 : parseInt(input.getAttribute('data-count'), 10) || 0;
    if (this.items[0]) this.items[0].quantity = 1 + count;
    this.updateSubTotal();
  }

  // Digital Download: hide the +N options, force "Just one" and show the note.
  // No-op on templates where the Extra Prints step isn't enabled.
  updateExtraPrintsAvailability() {
    const isDigital = this.isDigitalDownloadVariant();

    this.querySelectorAll('[data-sbs-extra-prints]').forEach((input) => {
      const count = parseInt(input.getAttribute('data-count'), 10) || 0;
      if (count > 0) {
        const pill = input.closest('.extra-prints__pill');
        if (pill) pill.hidden = isDigital;
      } else if (isDigital) {
        input.checked = true;
      }
    });

    const note = this.querySelector('[data-sbs-extra-prints-digital-note]');
    if (note) note.hidden = !isDigital;

    if (isDigital && this.items[0]) this.items[0].quantity = 1;
  }

  onAddExtra(ev) {
    let v_id = ev.target.dataset['v_id'];
    let v_price = ev.target.dataset['v_price'];
    let v_compare = ev.target.dataset['v_compare'];
    let bypassSubtotal = ev.target.dataset['bypassSubtotal'] === 'true';
    let item = {
      id: v_id,
      quantity: 1,
      price: v_price,
      compare: v_compare,
      bypassSubtotal: bypassSubtotal,
    };

    this.items.push(item);

    console.log('%cThis.items', 'background:green;color:white;padding:12px');
    console.log(this.items);

    this.updateSubTotal();
  }

  onRemoveExtra(ev) {
    let v_id = ev.target.v_id;
    console.log(v_id);
    this.items.forEach((item, arg) => {
      if(item.id == v_id) this.items.splice(arg, 1);
    });

    console.log('%cThis.items', 'background:green;color:white;padding:12px');
    console.log(this.items);

    this.updateSubTotal();
  }

  updateVariant(cur_index, value) {
    console.log(`${this.product.options[cur_index]}: `, value);

    let cur_options = this.cur_options.split(',');
    let new_options = [...cur_options];
    new_options[cur_index] = value;

    let subVariants = this.product.variants.filter(
      variant => variant.options[cur_index] == value
    );
    for (let i = 0; i < cur_options.length; i++) {
      if (i !== cur_index) {
        const availableCurOptions = [...new Set(subVariants.map(variant => variant.options[i]))];
        const curSubVariants = [...subVariants.filter(
          variant => variant.options[i] == cur_options[i]
        )];

        if (!curSubVariants.length) {
          new_options[i] = availableCurOptions.pop();
          subVariants = [...subVariants.filter(
            variant => variant.options[i] == new_options[i]
          )];
          document.querySelectorAll(`[data-step="${this.product.options[i]}"] option-item`).forEach(option => {
            if (option.dataset['v_option'] == new_options[i]) {
              option.classList.add("selected");
            } else {
              option.classList.remove("selected");
            }
          });
        } else {
          subVariants = [...curSubVariants];
        }
      }
    }
    this.cur_variant = subVariants.pop();
    this.cur_options = new_options.join();

    this.url.searchParams.set("variant", this.cur_variant.id);
    window.history.replaceState({}, "", this.url);

    this.items[0].id = this.cur_variant.id;
    this.items[0].price = this.cur_variant.price;
    
    Object.assign(this.items[0].properties, { ...this.uploadWrap.inputs.properties });

    this.updateExtraPrintsAvailability();
    this.updateSubTotal();

    if(this.cur_variant.featured_media) {

      let v_img = this.cur_variant.featured_media.id;
      let slidedImage = false;
  
      document.querySelectorAll('.mySwiper2 .swiper-slide img').forEach( (img, arg) => {
        if(img.dataset['id'] == v_img && slidedImage != true) {
          slidedImage = true;
          window.mySwiper.slideTo(arg);
        }
      });
    }

    const premiumStepsIndex = this.steps.findIndex(
      (step) => this.getVariantStepIndex(step) === cur_index
    );
    if (premiumStepsIndex >= 0) {
      this.updatePremium(premiumStepsIndex);
    }

    if (this.isDigitalDownloadVariant()) {
      document
        .querySelector('.extra-variant[data-v_id="29877512667222"]')
        ?.classList
        ?.add('hidden');
    } else {
      document
        .querySelector('.extra-variant[data-v_id="29877512667222"]')
        ?.classList
        ?.remove('hidden');
    }

    this.updateGiftMessageVisibility();
  }

  onAddCart() {
    if (this._addPending) return;
    this._addPending = true;
    if (window.FastTrack && window.FastTrack.isPending && window.FastTrack.isPending(this)) {
      document.addEventListener('fasttrack:change', () => {
        this._addPending = false;
        this.onAddCart();
      }, { once: true });
      return;
    }
    const items = [...this.items];
    var free_mug_index = -1;
    for (let index = 0; index < items.length; index++) {
      var item = items[index];
      if (item.properties != undefined) {
        if (item?.properties['__free-mug']){
          free_mug_index = index;
        }
      }
    }
    console.log("free mug index", free_mug_index);
    if (free_mug_index > 0){
      items.splice(free_mug_index, 1);
    }
    
    const sections = 'cart-drawer';

    let product_info = JSON.parse(document.querySelector('#step-block-product').textContent);
    let mug_vt_id = document.querySelector("step-block").getAttribute("mug-v_id");
    let main_item = this.items[0];
    // Safety net: never send a digital download with an extra-prints quantity.
    if (this.isDigitalDownloadVariant()) main_item.quantity = 1;
    let main_prop = main_item["properties"];
    main_prop["__time"] = Date.now();

    // Parent line: hidden at checkout via underscore prefix.
    if (
      this.giftMessageEnabled
      && this.giftMessageText
      && !this.isDigitalDownloadVariant()
    ) {
      main_prop['_Gift Message'] = this.giftMessageText;
    } else {
      delete main_prop['_Gift Message'];
      delete main_prop['Gift Message'];
    }

    let mug_prop = JSON.stringify(main_prop);
    mug_prop = JSON.parse(mug_prop);
    delete mug_prop["__step-product"];
    mug_prop["__free-mug"] = "true";
    let mug = {
      id: mug_vt_id,
      quantity: 1,
      price: 0,
      properties: mug_prop
    };
    
    let true_mug = false;
    for (let i = 0; i < product_info.variants.length; i++) {
      if (product_info.variants[i].id == main_item.id) {
        let main_variant = product_info.variants[i];
        if (main_variant.option2 != "Unframed") {
          true_mug = true;
        }
      }
    }

    if (true_mug && mug_vt_id != "") {
      items.push(mug);
    }

    if (
      this.giftMessageEnabled
      && this.giftMessageText
      && this.giftMessageVariantId
      && !this.isDigitalDownloadVariant()
    ) {
      items.push({
        id: this.giftMessageVariantId,
        quantity: 1,
        properties: {
          'Gift Message': this.giftMessageText,
          '__gift_message_addon': 'true',
          '__linked_time': String(main_prop['__time']),
        },
      });
    }

    // Fast Track (optional next-batch card) — one per-order line, linked to the parent.
    // window.FastTrack is only present when the next_batch block loaded fast-track.js.
    var ftLine = window.FastTrack && window.FastTrack.lineItem(this, String(main_prop['__time']));
    if (ftLine) items.push(ftLine);

    // document.querySelector('.atc-btn').classList.toggle("loading", true);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items,
            sections
        })
    })
    .then(res => {
        // /cart/add.js answers 4xx (e.g. 422 sold out / invalid line) with an error
        // body that fetch does NOT reject. Treat a non-OK response as a failure so a
        // failed add never reloads or opens the cart and wipes the in-progress state.
        if (!res.ok) return res.json().then(err => Promise.reject(err));
        return res.json();
    })
    .then(res => {
        console.log(res);
        let step_header = document.querySelector('.step-header-wrapper').outerHTML;
        let step_header_style = document.querySelector('#step-header-style').outerHTML;
        localStorage.setItem('step_header', step_header);
        localStorage.setItem('step_header_style', step_header_style);
        // document.querySelector('.atc-btn').classList.toggle("loading", true);
        // "Make another": stay on the product, but reload fresh so every field
        // (photo/UploadKit, extras, gift, variant, extra prints) resets cleanly.
        if (this._makeAnother) {
          this._makeAnother = false;
          try { sessionStorage.setItem('sbs_make_another', '1'); } catch (e) {}
          window.location.href = window.location.origin + window.location.pathname;
          return;
        }
        switch(window.cta_target) {
          case 'bundle':
            window.location.href = window.location.origin + '/pages/bundle-and-save';
            break;
          case 'checkout':
            window.location.href = window.location.origin + '/checkout';
            break;
          case 'cart':
            this._addPending = false;
            open_cart_drawer();
            break;
          default:
            this._addPending = false;
            reBuildCart();
            open_cart_drawer();
            // document.querySelector('.atc-btn').classList.toggle("loading", false);
        }
    })
    .catch(err => {
        // Failed add (or network error): keep the customer on the page with their
        // photo/extras/extra-prints intact — never reload or open the cart. Clear the
        // Make another spinner so the button isn't stuck loading with no feedback.
        this._makeAnother = false;
        this._addPending = false;
        if (this.makeAnotherBtn) this.makeAnotherBtn.classList.remove('loading');
        console.error('Add to cart failed — not reloading:', err);
    });

  }

  updateSubTotal() {
    let subTotal = 0;
    let symbol = this.cur_symbol;
    let rate = parseFloat(window.Shopify.currency.rate);
    let variantId;

    for (const item of this.items) {
      if (item.bypassSubtotal) continue;
      // Extra Prints bumps the main line's quantity; everything else is qty 1.
      subTotal += (parseInt(item.price) || 0) * (parseInt(item.quantity) || 1);
      variantId = item.id;
    }

    if (
      this.giftMessageEnabled
      && this.giftMessageText
      && this.giftMessagePrice
      && !this.isDigitalDownloadVariant()
    ) {
      subTotal += parseInt(this.giftMessagePrice) || 0;
    }

    // Fast Track add-on (optional next-batch card) — 0 when off/absent.
    if (window.FastTrack) subTotal += window.FastTrack.priceCents(this) || 0;

    const freeShippingThresholdCents = window.__themeFreeShippingThresholdCents ?? 10000;
    try {
      this.querySelector('.subtotal .money').setAttribute('data-variant-id',variantId);
      this.querySelector('.subtotal .money').innerHTML = `${symbol}${(subTotal / 100 ).toFixed(2)}`;
      if (subTotal < freeShippingThresholdCents) {
        this.querySelector('.step-freeshipping').innerHTML = `<p>You're only <span class="money">${symbol}${((freeShippingThresholdCents - subTotal)/100).toFixed(2)}</span> away from <strong>FREE SHIPPING</strong></p>`;
      } else {
        this.querySelector('.step-freeshipping').innerHTML = "<p>Congrats! You've earned <strong>FREE SHIPPING</strong></p>";
      }

      this.updateWasPrice();
    } catch (error) {
      console.error(error);
    }
  }
}

customElements.define('step-block', StepBlock);

class VariantOption extends HTMLElement {
  constructor() {
    super();
    this.updateOtionEv = new Event('option:change', {bubbles: true});

    this.addEventListener('click', () => {
      this.parentElement.querySelectorAll('variant-option').forEach(sibling => sibling.classList.toggle('selected', false));
      this.classList.toggle('selected', true);
      this.dispatchEvent(this.updateOtionEv);
    });
  }

}

customElements.define('variant-option', VariantOption);

class OptionContainer extends HTMLElement {
  constructor() {
    super();
    let target = this.dataset.option;
    this.targetEl = document.querySelector(`.design-option[data-option="${target}"]`);
    this.opener = this.targetEl.querySelector('.option-choose').parentElement;
    this.closer = document.querySelector('option-drawer .before-step');
    this.parent = this.parentElement;
    this.addActions();
  }

  init() {
    this.selectedEl = this.querySelector('variant-option.selected');
    let detailEl = this.selectedEl?.querySelector('[data-option-detail]'); 
    let imageEl = this.selectedEl?.querySelector('img'); 
  
    this.curOption = {
      title: this.selectedEl.dataset.optionValue,
      detail: detailEl?.innerHTML,
      image: imageEl?.src
    };
  }

  addActions() {
    this.addEventListener('option:change', this.updateCurOption.bind(this));
    this.opener.addEventListener('click', () => {
      this.open();
    });
    this.closer.addEventListener('click', () => {
      this.close();
    });
  }

  updateCurOption(ev) {
    this.curOption.title = ev.target.dataset.optionValue;

    ev.target.querySelector('[data-detail]') ? this.curOption.detail = ev.target.querySelector('[data-detail]').innerHTML : null;

    ev.target.querySelector('img') ? this.curOption.image = ev.target.querySelector('img').src : null;
  }

  updateUi() {
    console.log(this.curOption);
    this.curOption?.title ? this.targetEl.querySelector('.option-title').innerHTML = this.curOption.title : null;
    this.curOption?.detail ? this.targetEl.querySelector('.option-detail').innerHTML = this.curOption.detail : null;
    this.curOption?.image ? this.targetEl.querySelector('.option-image').querySelector('img').setAttribute("src", this.curOption.image) : null;
  }

  open() {
    let target = this.dataset.option;
    this.init();
    this.updateUi();
    this.parentElement.scrollTop = 0;
    let optionName = this.dataset.optionName;
    window.productData.options.forEach((option, arg) => {
      if(option == optionName) {
        document.querySelector('option-drawer').updatePremium(arg);
      }
    });
    this.parent.dataset.option = target;
    document.querySelector('option-drawer').dataset.option = target;
  }
  
  close() {
    this.init();
    this.updateUi();
    this.parent.dataset.option = 'frame';
    document.querySelector('option-drawer').dataset.option = 'frame';
  }
}

customElements.define('option-container', OptionContainer);

class SummaryDesign extends HTMLElement {
  constructor() {
    super();
    this.product = window.productData;
    this.cur_symbol = document.querySelector('#currency_symbol').textContent;
  }

  init() {
    let cur_symbol = this.cur_symbol;
    
    document.querySelector('option-drawer .summary-count .count').innerHTML = ms_num;
    this.querySelector('.summary-delete').classList.toggle('hidden', ms_num == 1);
    document.querySelectorAll('ms-catalog').forEach((catalog, arg) => {
      const target = this.querySelector(`.summary-item:nth-child(${arg + 2})`);
      if (catalog.className.includes('active')) {
        target.classList.toggle('active', true);
        let v_id = catalog.vt_id;
        const curVaraint = this.product.variants.find( variant => variant.id == v_id);

        target.querySelector('.summary-media').style.backgroundImage = `url(${catalog.upload_prop_direct_val})`;
        target.querySelector('.summary-title').innerHTML = this.product.title;
        for (let i = 0; i < this.product.options.length; i++) {
          target.querySelector(`.summary-option[data-option="${this.product.options[i]}"] .option-value`).innerHTML = curVaraint.options[i];
        }
        target.querySelector('.summary-price'). innerHTML = `${cur_symbol}${(curVaraint.price / 100).toFixed(2)}`;
        target.querySelector('.summary-edit').addEventListener('click', () => {
          if(catalog.className.includes('uploaded')) {
            catalog.querySelector('.edit-btn').dispatchEvent(new MouseEvent('click'));
          } else {
            document.querySelector('option-drawer').close();
            catalog.querySelector('.ms-photo-wrapper').dispatchEvent(new MouseEvent('click'));
            
          }
        });
        target.querySelector('.summary-delete').addEventListener('click', () => {
          let parent = target.parentElement;
          const index = Array.prototype.indexOf.call(parent.children, target);
          document.querySelector('.remove-modal').dataset.index = index;
          document.querySelector('.remove-modal').classList.remove('hidden');
        });
      }
      else {
        target.classList.toggle('active', false);
      }
    });
  }
}

customElements.define('summary-design', SummaryDesign);
class OptionDrawer extends HTMLElement {
  constructor() {
    super();
    this.product = window.productData;
    this.curVaraint = '';
    this.vt_id = '';
    this.price = '';
    this.curOption = '';
    this.target = '';
    this.cur_symbol = document.querySelector('#currency_symbol').textContent;
    this.applyer = this.querySelector('.apply-design');
    this.closer = this.querySelector('.drawer__close');
    this.atc = this.querySelector('.proceed-checkout a');
    this.addActions();
  }

  addActions() {
    this.closer.addEventListener('click', () => {
      this.close();
    });

    this.addEventListener('click', (e) => {
      const overlayClicked = this.querySelector('.design-container').contains(e.target);
      overlayClicked ? null : this.close();
    });

    this.addEventListener('option:change', this.updateVariant.bind(this));

    this.applyer.addEventListener('click', () => {
      this.applyDesign();
    });
    this.atc.addEventListener('click', (ev) => {
      ev.preventDefault();
      const items = this.items;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items
        })
      })
      .then(res => res.json())
      .then(res => {
        console.log(res);
        window.location.href = '/checkout';
      });
    });
  }

  updateOptions() {
    const curOption = this.curOption.split(',');
    this.querySelectorAll('variant-option').forEach(option => {
      if(curOption.includes(option.dataset.optionValue)) {
        option.classList.toggle('selected', true);
      } else {
        option.classList.toggle('selected', false);
      }
    });
    this.querySelectorAll('option-container').forEach(container => {
      container.init();
      container.updateUi();
    });
  }

  updateVariant(ev) {
    let optionName = ev.target.dataset.optionName;
    let optionValue = ev.target.dataset.optionValue;
    this.product.options.forEach((option, arg) => {
      if(option == optionName) {
        let curOption = this.curOption.split(',');
        curOption[arg] = optionValue;
        this.curOption = curOption.join(',');

        const curVaraint = this.product.variants.find(variant => {
          return variant.options.join(',') == curOption.join(',');
        });
        this.vt_id = curVaraint.id;
        this.price = curVaraint.price;
        this.updatePremium(arg);
        this.target.price = this.price;
        this.target.vt_id = this.vt_id;
        this.target.classList.add('designed');
        this.updateSubTotal();
      }
    });

    console.log(this.vt_id);
  }

  updatePremium(index) {
    let cur_symbol = this.cur_symbol;
    let curOption = this.curOption.split(',');
    const subVariants = this.product.variants.filter( variant => {
      let isPassed = true;
      let i = 0;

      do {
        if( i != index) {
          variant.options[i] === curOption[i] ? isPassed = true : isPassed = false;
        }
        if(!isPassed) return isPassed;
        i++;
      } while (i < curOption.length);
      return isPassed
    });

    let premiumPrices = {};
    let curPrice = this.price;

    subVariants.forEach( variant => {
      let delta = variant.price - curPrice;
      Object.assign(premiumPrices, {[variant.options[index]]: delta});
    });
    let target = this.product.options[index].toLowerCase();
    console.log(subVariants);
    console.log(premiumPrices);
  
    for (const key in premiumPrices) {
      premiumPrices[key] > 0 ? this.querySelector(`variant-option[data-option-value='${key}'] .premium-price`).innerHTML = `+${cur_symbol}${(premiumPrices[key] / 100).toFixed(2)}` : this.querySelector(`variant-option[data-option-value='${key}'] .premium-price`).innerHTML = null;
    }
  }

  updateSubTotal() {
    let subTotal = count_subtotal_price();
    let originalTotal = count_original_price ();
    let saveTotal = count_saving_price();
    try {
      this.querySelector('.design-header .summary-price').innerHTML = `${this.cur_symbol}${subTotal.toFixed(2)}`;
      this.querySelector('.design-footer .summary-price').innerHTML = `${this.cur_symbol}${subTotal.toFixed(2)}`;
      this.querySelector('.total-price').innerHTML = `${this.cur_symbol}${originalTotal.toFixed(2)}`;
      let reward = '';
      const freeShippingThresholdDollars = (window.__themeFreeShippingThresholdCents ?? 10000) / 100;
      this.querySelector('#reward-content span[data-free-shipping]').classList.toggle('hidden', subTotal < freeShippingThresholdDollars);
  
      reward = `You're Saving ${this.cur_symbol}${(saveTotal).toFixed(2)}`;
      this.querySelector('#reward-content span[data-saving]').innerHTML = reward;
    } catch (error) {
      console.error(error);
    }
  }
  applyDesign() {
    this.target.price = this.price;
    this.target.vt_id = this.vt_id;
    this.target.classList.add('designed');
    update_designed_num();
    if(this.dataset.option == 'frame') {
      this.close();
    } 
    else {
      this.querySelectorAll('option-container').forEach(container => {
        container.close();
      });
    }
    update_subtotal();
  }

  open(el, step='frame', items=null) {
    el ? null : el = document.querySelector('ms-catalog.active');
    const parent = document.querySelector('.ms-catalog-wrapper');
    const index = Array.prototype.indexOf.call(parent.children, el);
    const total = document.querySelectorAll('ms-catalog.active').length;
    document.querySelector('option-drawer .edit-tile').innerHTML = `${index + 1} / ${total}`;
    
    if(step == 'summary') {
      this.items = items;
      document.querySelector('summary-design').init();
      this.querySelector('.design-body').scrollTop = 0;
    } 
    this.dataset.option = step;
    this.target = el;
    this.vt_id = el.vt_id;
    this.price = el.price;
    let imgUrl = el.upload_prop_direct_val;
    this.querySelector('.design-preview .image-wrapper').style.backgroundImage = `url(${imgUrl})`;

    this.product.variants.forEach( variant => {
      if(variant.id == this.vt_id) {
        let options = variant.options;
        this.curOption = options.join(',');
      }
    });
    this.updateOptions();
    this.updateSubTotal();
    this.classList.toggle('open', true);
    document.querySelector('body').classList.toggle('option-drawer', true);
  }

  close() {
    this.dataset.option = 'frame';
    this.classList.toggle('open', false);
    document.querySelector('body').classList.toggle('option-drawer', false);
  }
}

customElements.define('option-drawer', OptionDrawer);